/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/core/datepicker/calendar-view/calendar-view.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '@angular/core/src/linker/element_ref';
import * as import10 from '@angular/core/src/linker/view_container';
import * as import11 from '../../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import12 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import13 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import14 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import15 from '@angular/core/src/linker/template_ref';
import * as import16 from '@angular/common/src/directives/ng_if';
import * as import17 from '@angular/common/src/directives/ng_class';
import * as import18 from '../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import19 from '@angular/common/src/directives/ng_for';
export class Wrapper_CalendarViewComponent {
  /*private*/ _eventHandler:Function;
  context:import0.CalendarViewComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  /*private*/ _expr_6:any;
  /*private*/ _expr_7:any;
  subscription0:any;
  constructor(p0:any,p1:any) {
    this._changed = false;
    this.context = new import0.CalendarViewComponent(p0,p1);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
    this._expr_7 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_openedCalendar(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.openedCalendar = currValue;
      this._expr_0 = currValue;
    }
  }
  check_locale(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.locale = currValue;
      this._expr_1 = currValue;
    }
  }
  check_format(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.format = currValue;
      this._expr_2 = currValue;
    }
  }
  check_position(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.position = currValue;
      this._expr_3 = currValue;
    }
  }
  check_disableDates(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.disableDates = currValue;
      this._expr_4 = currValue;
    }
  }
  check_rangeBound(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this._changed = true;
      this.context.rangeBound = currValue;
      this._expr_5 = currValue;
    }
  }
  check_selectedDate(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_6,currValue))) {
      this._changed = true;
      this.context.selectedDate = currValue;
      this._expr_6 = currValue;
    }
  }
  check_period(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_7,currValue))) {
      this._changed = true;
      this.context.period = currValue;
      this._expr_7 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) {
      if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); }
      this.context.ngDoCheck();
    }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.dateSelected.subscribe(_eventHandler.bind(view,'dateSelected'))); }
  }
}
var renderType_CalendarViewComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_CalendarViewComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.CalendarViewComponent>;
  _CalendarViewComponent_0_3:Wrapper_CalendarViewComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_CalendarViewComponent_Host0,renderType_CalendarViewComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'calendar-view',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_CalendarViewComponent0(this.viewUtils,this,0,this._el_0);
    this._CalendarViewComponent_0_3 = new Wrapper_CalendarViewComponent(this.renderer,new import9.ElementRef(this._el_0));
    this.compView_0.create(this._CalendarViewComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._CalendarViewComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.CalendarViewComponent) && (0 === requestNodeIndex))) { return this._CalendarViewComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._CalendarViewComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._CalendarViewComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const CalendarViewComponentNgFactory:import8.ComponentFactory<import0.CalendarViewComponent> = new import8.ComponentFactory<import0.CalendarViewComponent>('calendar-view',View_CalendarViewComponent_Host0,import0.CalendarViewComponent);
const styles_CalendarViewComponent:any[] = ([] as any[]);
class View_CalendarViewComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import10.ViewContainer) {
    super(View_CalendarViewComponent1,renderType_CalendarViewComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-day'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2:any = import3.inlineInterpolate(1,'',this.context.$implicit,'');
    if (import3.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_CalendarViewComponent4 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import10.ViewContainer) {
    super(View_CalendarViewComponent4,renderType_CalendarViewComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','-label'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2:any = import3.inlineInterpolate(1,'',this.parentView.parentView.parentView.context.todayLabel(),'');
    if (import3.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_CalendarViewComponent3 extends import2.AppView<any> {
  _el_0:any;
  _NgClass_0_3:import11.Wrapper_NgClass;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import10.ViewContainer;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import12.Wrapper_NgIf;
  _text_6:any;
  _map_11:any;
  /*private*/ _expr_12:any;
  /*private*/ _expr_13:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import10.ViewContainer) {
    super(View_CalendarViewComponent3,renderType_CalendarViewComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_11 = import3.pureProxy7((p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any):{[key: string]:any} => {
      return {
        '-today': p0,
        '-selected': p1,
        '-start': p2,
        '-range': p3,
        '-end': p4,
        '-disabled': p5,
        '-out': p6
      }
      ;
    });
    this._expr_12 = import1.UNINITIALIZED;
    this._expr_13 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray4(4,'class','-date','tabindex','0'),(null as any));
    this._NgClass_0_3 = new import11.Wrapper_NgClass(this.parentView.parentView.parentView.injectorGet(import13.IterableDiffers,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import14.KeyValueDiffers,this.parentView.parentView.parentIndex),new import9.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'style','visibility: hidden;'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_5 = new import10.ViewContainer(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import15.TemplateRef_(this,5,this._anchor_5);
    this._NgIf_5_6 = new import12.Wrapper_NgIf(this._vc_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'mouseup',(null as any)),this.eventHandler(this.handleEvent_0));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import15.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import16.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    if (((token === import17.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = '-date';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_11(this.context.$implicit.today,this.context.$implicit.selected,this.context.$implicit.start,this.context.$implicit.range,this.context.$implicit.end,this.context.$implicit.disabled,this.context.$implicit.out);
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_5_0_0:any = this.context.$implicit.today;
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    const currVal_12:any = import3.inlineInterpolate(1,'',this.context.$implicit.number,'\n                        ');
    if (import3.checkBinding(throwOnChange,this._expr_12,currVal_12)) {
      this.renderer.setText(this._text_1,currVal_12);
      this._expr_12 = currVal_12;
    }
    const currVal_13:any = import3.inlineInterpolate(1,'',this.context.$implicit.number,'');
    if (import3.checkBinding(throwOnChange,this._expr_13,currVal_13)) {
      this.renderer.setElementProperty(this._el_2,'id',currVal_13);
      this._expr_13 = currVal_13;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 5)) { return new View_CalendarViewComponent4(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'mouseup')) {
      const pd_sub_0:any = ((<any>(!(this.context.$implicit.disabled || this.context.$implicit.out) && this.parentView.parentView.context.select(this.context.$implicit.date))) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_CalendarViewComponent2 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import10.ViewContainer;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import18.Wrapper_NgFor;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import10.ViewContainer) {
    super(View_CalendarViewComponent2,renderType_CalendarViewComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-week'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import10.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import15.TemplateRef_(this,2,this._anchor_2);
    this._NgFor_2_6 = new import18.Wrapper_NgFor(this._vc_2.vcRef,this._TemplateRef_2_5,this.parentView.parentView.injectorGet(import13.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','clearfix'),(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._el_4,
      this._text_5
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import15.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import19.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.context.$implicit;
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 2)) { return new View_CalendarViewComponent3(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}
var renderType_CalendarViewComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_CalendarViewComponent,{});
export class View_CalendarViewComponent0 extends import2.AppView<import0.CalendarViewComponent> {
  _el_0:any;
  _NgClass_0_3:import11.Wrapper_NgClass;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _NgClass_10_3:import11.Wrapper_NgClass;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _anchor_25:any;
  /*private*/ _vc_25:import10.ViewContainer;
  _TemplateRef_25_5:any;
  _NgFor_25_6:import18.Wrapper_NgFor;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _text_29:any;
  _anchor_30:any;
  /*private*/ _vc_30:import10.ViewContainer;
  _TemplateRef_30_5:any;
  _NgFor_30_6:import18.Wrapper_NgFor;
  _text_31:any;
  _text_32:any;
  _text_33:any;
  _text_34:any;
  _map_43:any;
  _map_44:any;
  /*private*/ _expr_45:any;
  /*private*/ _expr_46:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_CalendarViewComponent0,renderType_CalendarViewComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._map_43 = import3.pureProxy7((p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any):{[key: string]:any} => {
      return {
        '-fade-datepicker': p0,
        '-bottom-left': p1,
        '-bottom-center': p2,
        '-bottom-right': p3,
        '-top-left': p4,
        '-top-center': p5,
        '-top-right': p6
      }
      ;
    });
    this._map_44 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'disabled-prev-month': p0};
    });
    this._expr_45 = import1.UNINITIALIZED;
    this._expr_46 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-datepicker -show-datepicker'),(null as any));
    this._NgClass_0_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import13.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import14.KeyValueDiffers,this.parentIndex),new import9.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','datepicker-container'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','datepicker-marker -allow-hover'),(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','datepicker-content'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','datepicker-header'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'i',new import3.InlineArray8(6,'class','eva-icon-arrow-left datepicker-prev','id','prev','tabindex','0'),(null as any));
    this._NgClass_10_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import13.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import14.KeyValueDiffers,this.parentIndex),new import9.ElementRef(this._el_10),this.renderer);
    this._text_11 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_8,'i',new import3.InlineArray8(6,'class','eva-icon-arrow-right datepicker-next','id','next','tabindex','0'),(null as any));
    this._text_13 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_8,'span',new import3.InlineArray4(4,'class','-month','name','month'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_8,'span',new import3.InlineArray4(4,'class','-year','name','year'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_8,'\n            ',(null as any));
    this._text_20 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','datepicker-body'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n                ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_21,'div',new import3.InlineArray2(2,'class','-week'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n                    ',(null as any));
    this._anchor_25 = this.renderer.createTemplateAnchor(this._el_23,(null as any));
    this._vc_25 = new import10.ViewContainer(25,23,this,this._anchor_25);
    this._TemplateRef_25_5 = new import15.TemplateRef_(this,25,this._anchor_25);
    this._NgFor_25_6 = new import18.Wrapper_NgFor(this._vc_25.vcRef,this._TemplateRef_25_5,this.parentView.injectorGet(import13.IterableDiffers,this.parentIndex),this.ref);
    this._text_26 = this.renderer.createText(this._el_23,'\n                    ',(null as any));
    this._el_27 = import3.createRenderElement(this.renderer,this._el_23,'div',new import3.InlineArray2(2,'class','clearfix'),(null as any));
    this._text_28 = this.renderer.createText(this._el_23,'\n                ',(null as any));
    this._text_29 = this.renderer.createText(this._el_21,'\n                ',(null as any));
    this._anchor_30 = this.renderer.createTemplateAnchor(this._el_21,(null as any));
    this._vc_30 = new import10.ViewContainer(30,21,this,this._anchor_30);
    this._TemplateRef_30_5 = new import15.TemplateRef_(this,30,this._anchor_30);
    this._NgFor_30_6 = new import18.Wrapper_NgFor(this._vc_30.vcRef,this._TemplateRef_30_5,this.parentView.injectorGet(import13.IterableDiffers,this.parentIndex),this.ref);
    this._text_31 = this.renderer.createText(this._el_21,'\n            ',(null as any));
    this._text_32 = this.renderer.createText(this._el_6,'\n        ',(null as any));
    this._text_33 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_34 = this.renderer.createText(this._el_0,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'keypress',(null as any)),this.eventHandler(this.handleEvent_2));
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_10,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_10));
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_12,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_12));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._anchor_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._text_29,
      this._anchor_30,
      this._text_31,
      this._text_32,
      this._text_33,
      this._text_34
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.NgClass) && (10 === requestNodeIndex))) { return this._NgClass_10_3.context; }
    if (((token === import15.TemplateRef) && (25 === requestNodeIndex))) { return this._TemplateRef_25_5; }
    if (((token === import19.NgFor) && (25 === requestNodeIndex))) { return this._NgFor_25_6.context; }
    if (((token === import15.TemplateRef) && (30 === requestNodeIndex))) { return this._TemplateRef_30_5; }
    if (((token === import19.NgFor) && (30 === requestNodeIndex))) { return this._NgFor_30_6.context; }
    if (((token === import17.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 34)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = 'eva-datepicker -show-datepicker';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_43(!this.context.openedCalendar,(this.context.position == 'bottomLeft'),(this.context.position == 'bottomCenter'),(this.context.position == 'bottomRight'),(this.context.position == 'topLeft'),(this.context.position == 'topCenter'),(this.context.position == 'topRight'));
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_10_0_0:any = 'eva-icon-arrow-left datepicker-prev';
    this._NgClass_10_3.check_klass(currVal_10_0_0,throwOnChange,false);
    const currVal_10_0_1:any = this._map_44(this.context.disablePrevArrow);
    this._NgClass_10_3.check_ngClass(currVal_10_0_1,throwOnChange,false);
    this._NgClass_10_3.ngDoCheck(this,this._el_10,throwOnChange);
    const currVal_25_0_0:any = this.context.weekdayNames;
    this._NgFor_25_6.check_ngForOf(currVal_25_0_0,throwOnChange,false);
    this._NgFor_25_6.ngDoCheck(this,this._anchor_25,throwOnChange);
    const currVal_30_0_0:any = this.context.weeks;
    this._NgFor_30_6.check_ngForOf(currVal_30_0_0,throwOnChange,false);
    this._NgFor_30_6.ngDoCheck(this,this._anchor_30,throwOnChange);
    this._vc_25.detectChangesInNestedViews(throwOnChange);
    this._vc_30.detectChangesInNestedViews(throwOnChange);
    const currVal_45:any = import3.inlineInterpolate(1,'',this.context.current.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_45,currVal_45)) {
      this.renderer.setText(this._text_15,currVal_45);
      this._expr_45 = currVal_45;
    }
    const currVal_46:any = import3.inlineInterpolate(1,'',this.context.current.year,'');
    if (import3.checkBinding(throwOnChange,this._expr_46,currVal_46)) {
      this.renderer.setText(this._text_18,currVal_46);
      this._expr_46 = currVal_46;
    }
  }
  destroyInternal():void {
    this._vc_25.destroyNestedViews();
    this._vc_30.destroyNestedViews();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 25)) { return new View_CalendarViewComponent1(this.viewUtils,this,25,this._anchor_25,this._vc_25); }
    if ((nodeIndex == 30)) { return new View_CalendarViewComponent2(this.viewUtils,this,30,this._anchor_30,this._vc_30); }
    return (null as any);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'keypress')) {
      const pd_sub_0:any = ((<any>this.context.preventClose($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_10(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.prevMonth()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_12(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.nextMonth()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/core/datepicker/calendar-view/calendar-view.component.ngfactory.ts